import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { TafLogo } from "@/components/Brand";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      window.location.replace("/login");
      return;
    }
    loginWithGoogle(sid)
      .then(() => {
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      })
      .catch((err) => {
        const msg = err?.response?.data?.detail || "Αποτυχία σύνδεσης με Google";
        setError(msg);
        setTimeout(() => window.location.replace("/login?google_error=" + encodeURIComponent(msg)), 2800);
      });
  }, [loginWithGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F1] p-6" data-testid="auth-callback">
      <div className="text-center max-w-sm">
        <TafLogo height={48} />
        {error ? (
          <>
            <p className="font-serif text-xl text-[#A1493A] mt-6" data-testid="auth-callback-error">{error}</p>
            <p className="text-[#6F6A60] text-sm mt-2">Ανακατεύθυνση στη σελίδα σύνδεσης…</p>
          </>
        ) : (
          <>
            <div className="mt-6 h-8 w-8 mx-auto rounded-full border-2 border-[#C86235] border-t-transparent animate-spin" />
            <p className="text-[#45423C] font-serif text-xl mt-5">Σύνδεση με Google…</p>
            <p className="text-[#6F6A60] text-sm mt-1">Ένα λεπτό, σας συνδέουμε με ασφάλεια.</p>
          </>
        )}
      </div>
    </div>
  );
}
